(() => {
  function initialize() {
    const root = document.querySelector('.ycg-review');
    if (!root || root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    if (root.dataset.category) {
      root.querySelectorAll('.mobile-toc a').forEach(link => link.addEventListener('click', () => {
        link.closest('details').open = false;
      }));
      return;
    }
    const keys = ["green","white","oolong","black","dark","yellow"];
    const articles = [...root.querySelectorAll('article.guide')];
    const categories = [...root.querySelectorAll('.categories button')];
    function reveal(index) {
      articles.forEach((article, i) => { article.hidden = i !== index; });
      categories.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
    function fromHash() {
      const hash = window.location.hash.slice(1);
      const index = keys.findIndex(key => hash === key || hash.startsWith(key + '-'));
      if (index >= 0) reveal(index);
    }
    root.querySelectorAll('[data-guide]').forEach(button => button.addEventListener('click', () => {
      const index = Number(button.dataset.guide);
      reveal(index);
      window.history.replaceState(null, '', '#' + keys[index]);
      window.scrollTo({top:0,behavior:'auto'});
    }));
    root.querySelectorAll('.mobile-toc a').forEach(link => link.addEventListener('click', () => {
      link.closest('details').open = false;
    }));
    window.addEventListener('hashchange', fromHash);
    fromHash();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
